import React, { Component } from 'react'
// import './style.scss'
import '../../Assets/Styles/Social.css';

import Facebook from './react.facebook'
import Twitter from './react.twitter'
import Insta from './react.insta'


export default class ShareContainer extends Component {
	constructor(props) {
    super(props)

    this.state = {
      'shareDimensions': {
        width: 24,
        height: 24
      }
    }
  }

  // componentDidMount() {
  //   // this.convertToSVG()
  // }

  // convertToSVG() {
  //   const el = ReactDOM.findDOMNode(this)

  //   $(el).find('img').each(function(){
  //     var $img = $(this)
  //     var imgID = $img.attr('id')
  //     var imgClass = $img.attr('class')
  //     var imgURL = $img.attr('src')

  //     $.get(imgURL, function(data) {
  //       // Get the SVG tag, ignore the rest
  //       var $svg = $(data).find('svg')

  //       // Add replaced image's ID to the new SVG
  //       if(typeof imgID !== 'undefined') {
  //           $svg = $svg.attr('id', imgID)
  //       }
  //       // Add replaced image's classes to the new SVG
  //       if(typeof imgClass !== 'undefined') {
  //           $svg = $svg.attr('class', imgClass+' replaced-svg')
  //       }

  //       // Remove any invalid XML tags as per http://validator.w3.org
  //       $svg = $svg.removeAttr('xmlns:a')

  //       // Replace image with new SVG
  //       $img.replaceWith($svg)

  //   }, 'xml');
  //   });
  // }


  render() {
    let styles = {
      width: this.state.shareDimensions.width,
      height: this.state.shareDimensions.height
    }
    return (
      <div className="SocialContainer">
        <Facebook url='https://www.facebook.com/marvelstudios/' share={false} styles={styles}/>
        <Twitter url='https://twitter.com/marvelstudios' share={false} styles={styles}/>
        <Insta url='https://www.instagram.com/marvelstudios/' share={false} styles={styles}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/react.SocialContainer/index.js